<template>
  <v-card class="base-card shadow mt-4">
    <CardFieldRow
      class="ma-0 pl-1 py-2"
      label="Сотрудник, отправивший  работу на проверку"
      :value="creatorName"
      disabled
    />
  </v-card>
</template>

<script>
import CardFieldRow from '@/components/ui/row/CardFieldRow.vue'

export default {
  name: 'CreatorCard',
  components: { CardFieldRow },

  props: {
    creatorName: String
  }
}
</script>

<style></style>
